module.exports = __webpack_public_path__ + "4f7ad7c174c3fdaaa1a416424cb5ee67.png";


//////////////////
// WEBPACK FOOTER
// ./app/images/backdrop_img.png
// module id = 3844
// module chunks = 0